package com.trevorwiebe.timesheet.core.domain

/** API key for the Google Geocoding API, supplied by each platform's Koin startup. */
data class GeocodingConfig(val apiKey: String)

data class GeocodePoint(
    val latitude: Double,
    val longitude: Double,
    val formattedAddress: String
)

interface GeocodingRepository {
    /** Resolves a free-text address to coordinates. TSResult.data is a [GeocodePoint]. */
    suspend fun geocode(address: String): TSResult
}
